import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Typography } from "@mui/material";
import theme from "../../theme";
import moment from "moment";
import { getActivityLog } from "../../api/activityApi";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import LoadingSpinner from "../../common/components/LoadingSpinner";

const RecentActivites = () => {
    const dispatch = useDispatch();
    const { loading, user } = useSelector((state) => state.auth);
    const [activities, setActivity] = useState([]);

    const getBackgroundColor = (index) => {
        // Define colors for each position in the 4-item cycle
        const colors = [
            "#F9DFCD", // for indices 0, 4, 8, 12...
            "#D0FFD3", // for indices 1, 5, 9, 13...
            "#FFFCCF", // for indices 2, 6, 10, 14...
            "#F9CDE6"  // for indices 3, 7, 11, 15...
        ];

        return colors[index % 4];
    };

    const getHistory = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getActivityLog(user?.student_id);
            setActivity(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getHistory();
        }
    }, [user]);

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>My Recent Activites</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>Your latest actions and updates at a glance.</Typography>
                            </Box>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    activities?.length > 0 ? (
                        <Box
                            sx={{
                                height: '31vh',
                                overflow: 'auto'
                            }}
                        >
                            {activities.map((a, index) => {
                                return (
                                    <Fragment key={index}>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            padding="10px"
                                            sx={{
                                                background: getBackgroundColor(index),
                                                borderRadius: 1,
                                                my: 1
                                            }}
                                        >
                                            <Box sx={{ width: '80%' }}>
                                                <Typography fontSize={15} fontWeight="600">{a.title}</Typography>
                                                <Typography fontSize={13} color={theme.palette.background.dark}>{a.description}</Typography>
                                            </Box>
                                            <Typography
                                                fontSize={14}
                                                color={theme.palette.background.dark}
                                                sx={{ whiteSpace: 'nowrap' }}
                                            >
                                                {moment(a.created_at).fromNow()}
                                            </Typography>
                                        </Box>
                                    </Fragment>
                                )
                            })}
                        </Box>
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                        >
                            <Typography color={theme.palette.background.dark}>No Activites Found</Typography>
                        </Box>
                    )
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default RecentActivites;